import { getTaxesHeaderCalcs } from 'api/v2/taxes';
import useQuery from 'hooks/react-query/useQuery';

const useTaxHeaderMeta = (year?: number) => {
  return useQuery(
    ['TAX_HEADER_CALCULATIONS', year],
    () => getTaxesHeaderCalcs(year),
    {
      gcTime: 0,
    },
  );
};

export default useTaxHeaderMeta;
